export class Subject1073Layout {
	public sections = [
		{
			title: 'Subject',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeBorrower'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectPropertyOwnerName'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectOccupancyType'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectRightsType'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectName'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectPhaseIdentifier'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectCensusTract'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectMapReference'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectPropertyTaxYear'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectPropertyTaxTotalTaxAmount',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectSpecialTaxAmount',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectCounty'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectHOAPayment',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectHOAPaymentFrequency'
						}
					}
				],
				[
					{
						cssClass: 'col-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectAssessorsParcel'
						}
					}
				],
				[
					{
						cssClass: 'col-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectLegalDescription'
						}
					}
				]
			]
		},
		{
			title: 'Contract',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractReviewedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractReviewComment'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectSaleType'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractPrice',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractDate'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractSellerIsOwner',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractDataSource'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractSalesConcessionIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractSalesUndefinedConcessionAmountIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractSalesConcessionAmount',
							displayType: 'currency'
						}
					}
				],
				[
					{
						cssClass: 'col-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVContractSalesConcessionDescription'
						}
					}
				]
			]
		},
		{
			title: 'Listing History',
			items: [
				[
					{
						cssClass: 'col-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVListingHistoryIndicator',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVDaysOnMarketDescription"
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVListedWithinPreviousYearDescription'
						}
					}
				]
			]
		},
		{
			title: 'Sale History',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalePriorTransferSubjectIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Date of Sale/Transfer' },
								{ label: 'Price of Sale/Transfer' },
								{ label: 'Data Source(s)' },
								{ label: 'Effective Date of Data Source(s)' }
							],
							rows: [
								{
									cols: [
										{
											options: {
												path:
													"CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVCompPriorSaleDate",
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													"CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVCompPriorSalePrice",
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													"CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVCompPriorSaleDataSource",
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path:
													"CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVCompPriorSaleEffectiveDate",
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalePriorSubjectDataSource'
						}
					}
				]
			]
		},
		{
			title: 'Site',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteTopography'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteSize'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteDensity'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVViewOverallRatingType"
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVViewFactor1"
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVViewFactor2"
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVOverallLocationRatingType"
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVOverallLocationFactor1"
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVOverallLocationFactor2"
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteZoningClassification'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteZoningDescription'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteZoningCompliance'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSITEZoningPermitRebuildToCurrentDensityIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteHighestBestUse',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteHighestBestUseDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteAdverseSite',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteAdverseSiteDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteFEMAFloodHazardAreaIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteFEMAFloodZone'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteFEMAMapNumber'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSiteFEMAMapDate'
						}
					}
				]
			]
		},
		{
			title: 'Utilities & Off-Site Improvements',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [{}, { label: 'Id Public?' }, { label: 'Description (if not public)' }],
							rows: [
								{
									cssClass: '',
									cols: [
										{
											options: { label: 'Electric' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityElectricity',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityElectricityOtherDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cssClass: '',
									cols: [
										{
											options: {
												label: 'Gas'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityGas',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityGasOtherDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cssClass: '',
									cols: [
										{
											options: {
												label: 'Water'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityWater',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityWaterOtherDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cssClass: '',
									cols: [
										{
											options: {
												label: 'Sewer'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilitySewer',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilitySewerOtherDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [{}, { label: 'Public' }, { label: 'Private' }, { label: 'Description' }],
							rows: [
								{
									cssClass: '',
									cols: [
										{
											options: {
												label: 'Street'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityStreetPublic',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityStreetPrivate',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityStreetDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cssClass: '',
									cols: [
										{
											options: {
												label: 'Alley'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityAlleyPublic',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityAlleyPrivate',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityAlleyDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityAndOffSiteImprovement',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVUtilityAndOffSiteImprovementComment'
						}
					}
				]
			]
		}
	];
}
